/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
import { SerdesUtils } from "@amzn/coral-typescript-types-pieces";
/**
 * <p>This represents the list of option numbers which will be returned in multiple choice response<\/p>
 **/
export class optionNumberList extends Array {
    constructor(param) {
        if (typeof param === "number") {
            super(param);
        }
        else {
            super();
            this.push(...param);
        }
        Object.setPrototypeOf(this, Object.create(optionNumberList.prototype));
    }
    static fromJson(data) {
        return new optionNumberList(data.map((datum) => SerdesUtils.identityFunction(datum)));
    }
    static toJson(data) {
        return data.map((datum) => SerdesUtils.identityFunction(datum));
    }
}
/**
 * Throw an exception if the given instance fails any Coral validations.
 *
 * @param data [unknown]
 * @return [optionNumberList] - a validated instance.
 * @throws ValidationException
 * @see https://w.amazon.com/bin/view/Coral/Manual/Model/XML/Constraint
 */
export function validateOptionnumberlist(data) {
    // TODO: Actually implement this!
    return data;
}
